import React from "react";
import { History } from "lucide-react";
import { useApi } from "../hooks/useApi";
import { useLang } from "../i18n/LanguageContext";

export function LeadershipTimeline() {
  const { data } = useApi("/governance/history");
  const { t } = useLang();
  if (!data || data.length === 0) return null;
  return (
    <div className="mt-20" data-testid="leadership-timeline">
      <p className="eyebrow text-gold">{t("Our history")}</p>
      <h2 className="mt-1 flex items-center gap-3 font-serif-display text-3xl font-bold text-crimson"><History size={26} className="text-gold" /> {t("Past Executive Boards")}</h2>
      <p className="mt-2 max-w-2xl text-muted-foreground">{t("The leaders who have stewarded the association since 2010.")}</p>
      <ol className="relative mt-10 border-l-2 border-gold/50 pl-8">
        {data.map((term, i) => (
          <li key={term.id} className="relative mb-12 animate-fade-up last:mb-0" style={{ animationDelay: `${i * 80}ms` }} data-testid={`timeline-term-${term.id}`}>
            <span className="absolute -left-[41px] top-1 flex h-5 w-5 items-center justify-center rounded-full border-2 border-gold bg-crimson shadow-[0_0_0_6px_rgba(217,155,38,0.2)]" />
            <div className="font-mono-accent text-2xl font-bold text-crimson" data-testid={`timeline-label-${term.id}`}>{term.label}</div>
            {term.note && <p className="mt-1 max-w-2xl text-sm italic text-muted-foreground">{term.note}</p>}
            <div className="mt-4 grid gap-2 sm:grid-cols-2 lg:grid-cols-3">
              {term.members.map((m, j) => (
                <div key={`${m.title}-${m.name}`} className="rounded-xl border border-gold/25 bg-parchment-card px-4 py-3" data-testid={`timeline-member-${term.id}-${j}`}>
                  <p className="eyebrow text-[10px] text-gold">{m.title}</p>
                  <p className="font-semibold text-foreground">{m.name}</p>
                </div>
              ))}
            </div>
          </li>
        ))}
      </ol>
    </div>
  );
}
